class User {
  constructor(props) {
    this.id = props.id
    this.fbUserId = props.fbUserId
    this.name = props.name
    this.image = props.image
  }
}

export default User